import { render, staticRenderFns } from "./PriceFrontSupport.vue?vue&type=template&id=ac0b8804&scoped=true&"
import script from "./PriceFrontSupport.vue?vue&type=script&lang=js&"
export * from "./PriceFrontSupport.vue?vue&type=script&lang=js&"
import style0 from "./PriceFrontSupport.vue?vue&type=style&index=0&id=ac0b8804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0b8804",
  null
  
)

export default component.exports